/**
 * Navigation helper — resolves nav item text to correct href
 * Handles subpage navigation and content page links
 *
 * Alias-Map: Maps industry-specific nav labels to subpage URLs.
 * E.g. "Behandlungen" (Zahnarzt) = "Leistungen" (Treuhand) → angebot.html
 */

// Alias lists for each subpage
const angebotAliases: string[] = [
  'angebot', 'angebote', 'leistungen', 'behandlungen', 'services',
  'preise', 'pakete', 'tarife', 'dienstleistungen', 'pricing',
  'gerichte', 'speisekarte', 'menu', 'men\u00fc', 'kurse', 'programme',
  'trainings', 'objekte', 'immobilien', 'projekte', 'portfolio',
];

const methodenAliases: string[] = [
  'methoden', 'methodik', 'vorgehen', 'philosophie', 'konzept',
  'arbeitsweise', 'ansatz', 'process', 'methods', 'technik',
  'technologie', 'behandlungskonzept', 'unser ansatz', 'so arbeiten wir',
];

const ueberMichAliases: string[] = [
  '\u00fcber mich', 'uber mich', 'ueber mich',
  '\u00fcber uns', 'uber uns', 'ueber uns',
  'team', 'praxis', 'kanzlei', 'atelier', 'studio', 'agentur',
  'b\u00fcro', 'buro', 'about', 'about us', 'unser team',
  'wer wir sind', 'das team', 'salon',
];

export function resolveNavHref(
  text: string,
  settings: any,
  isSubpage?: boolean,
): string {
  const lower = (text || '').toLowerCase().trim();

  // Direct page matches (exact page names)
  if (settings.generateAngebot && angebotAliases.includes(lower)) {
    return 'angebot.html';
  }
  if (settings.generateMethoden && methodenAliases.includes(lower)) {
    return 'methoden.html';
  }
  if (settings.generateUeberMich && ueberMichAliases.includes(lower)) {
    return 'ueber-mich.html';
  }

  // Legal pages
  if (lower === 'impressum' && settings.generateImpressum) return 'impressum.html';
  if (lower === 'datenschutz' && settings.generateDatenschutz) return 'datenschutz.html';
  if ((lower === 'agb' || lower === 'allgemeine geschäftsbedingungen') && settings.generateAgb) return 'agb.html';

  // Default: anchor link (on same page or back to index)
  const anchor = '#' + lower.replace(/\s/g, '-');
  return isSubpage ? 'index.html' + anchor : anchor;
}
